import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import NavBar from './components/NavBar';
import MapPage from './pages/MapPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import './App.css';

function PrivateRoute({ children }) {
    const { user, loading } = useAuth();

    if (loading) return <div className='loading-screen'><div className='spinner' /></div>;

    return user ? children : <Navigate to='/login' replace />;
}

function AppRoutes() {
    const { user } = useAuth();

    return ( <
        > { user && <NavBar /> }
        <Routes>
          <Route path='/login' element={user ? <Navigate to='/' /> : <LoginPage />} />
          <Route path='/register' element={user ? <Navigate to='/' /> : <RegisterPage />} />
          <Route path='/' element={<PrivateRoute><MapPage /></PrivateRoute>} />
          <Route path='/profile' element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
          <Route path='*' element={<Navigate to='/' />} />
        </Routes> <
        />
    );
}

export default function App() {
    return (
        <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
    );
};
